var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('SectionContentWrapper',[_c('div',{staticClass:"logos"},[_c('a',{staticClass:"logo-link",attrs:{"href":"https://autopay.pl/","title":"Strona Autopay"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }